export type DesignTab = 'colors' | 'fonts';

export type FontCategoryId =
  | 'navigation'
  | 'body'
  | 'pageHeaders'
  | 'subheaders'
  | 'menus'
  | 'menuSections'
  | 'menuItems';

export type ColorCategoryId =
  | 'navigationBackground'
  | 'websiteBackground'
  | 'onlineOrderingBackground'
  | 'onlineOrderingActiveSelections';

export type FontRow = { family: string; color: string };

export const FONT_CATEGORIES: { id: FontCategoryId; label: string }[] = [
  { id: 'navigation', label: 'navigation' },
  { id: 'body', label: 'body' },
  { id: 'pageHeaders', label: 'page headers' },
  { id: 'subheaders', label: 'subheaders' },
  { id: 'menus', label: 'menus' },
  { id: 'menuSections', label: 'menu sections' },
  { id: 'menuItems', label: 'menu items' }
];

export const FONT_ONLY_CATEGORIES: FontCategoryId[] = ['body', 'menuItems'];

export const COLOR_CATEGORIES: { id: ColorCategoryId; label: string }[] = [
  { id: 'navigationBackground', label: 'navigation background color' },
  { id: 'websiteBackground', label: 'website background color' },
  { id: 'onlineOrderingBackground', label: 'online ordering background' },
  {
    id: 'onlineOrderingActiveSelections',
    label: 'online ordering active selections & +1 buttons'
  }
];

export const DEFAULT_COLOR = '#000000';
